import React from 'react';

// רינדור שדה בודד לפי type. value ו-onChange מנוהלים ב-FormPage.
// answers[fId] מחזיק: string (רוב הסוגים) | string[] (checkbox) | boolean|null (yesno).
const FormFieldRender = ({ field, value, onChange }) => {
    const { fId, type, label, required, options = [] } = field;

    const wrapClass = 'formFieldWrap';
    const labelEl = (
        <label className="formFieldLabel" htmlFor={fId}>
            {label}
            {required && <span className="formFieldReq"> *</span>}
        </label>
    );

    switch (type) {
        case 'longText':
            return (
                <div className={wrapClass}>
                    {labelEl}
                    <textarea
                        id={fId}
                        className="formFieldInput formFieldTextarea"
                        value={value || ''}
                        onChange={(e) => onChange(fId, e.target.value)}
                    />
                </div>
            );

        case 'number':
            return (
                <div className={wrapClass}>
                    {labelEl}
                    <input
                        id={fId}
                        type="number"
                        className="formFieldInput"
                        value={value == null ? '' : value}
                        onChange={(e) => onChange(fId, e.target.value)}
                    />
                </div>
            );

        case 'time':
            return (
                <div className={wrapClass}>
                    {labelEl}
                    <input
                        id={fId}
                        type="time"
                        className="formFieldInput"
                        value={value || ''}
                        onChange={(e) => onChange(fId, e.target.value)}
                    />
                </div>
            );

        case 'date':
            return (
                <div className={wrapClass}>
                    {labelEl}
                    <input
                        id={fId}
                        type="date"
                        className="formFieldInput"
                        value={value || ''}
                        onChange={(e) => onChange(fId, e.target.value)}
                    />
                </div>
            );

        case 'radio':
            return (
                <div className={wrapClass}>
                    {labelEl}
                    <div className="formFieldOptions">
                        {options.map((opt, i) => (
                            <label key={i} className="formFieldOption">
                                <input
                                    type="radio"
                                    name={fId}
                                    value={opt}
                                    checked={value === opt}
                                    onChange={() => onChange(fId, opt)}
                                />
                                <span>{opt}</span>
                            </label>
                        ))}
                    </div>
                </div>
            );

        case 'checkbox': {
            const arr = Array.isArray(value) ? value : [];
            const toggle = (opt) => {
                const next = arr.includes(opt) ? arr.filter(o => o !== opt) : [...arr, opt];
                onChange(fId, next);
            };
            return (
                <div className={wrapClass}>
                    {labelEl}
                    <div className="formFieldOptions">
                        {options.map((opt, i) => (
                            <label key={i} className="formFieldOption">
                                <input
                                    type="checkbox"
                                    checked={arr.includes(opt)}
                                    onChange={() => toggle(opt)}
                                />
                                <span>{opt}</span>
                            </label>
                        ))}
                    </div>
                </div>
            );
        }

        case 'yesno':
            return (
                <div className={wrapClass}>
                    {labelEl}
                    <div className="formFieldOptions">
                        <label className="formFieldOption">
                            <input
                                type="radio"
                                name={fId}
                                checked={value === true}
                                onChange={() => onChange(fId, true)}
                            />
                            <span>כן</span>
                        </label>
                        <label className="formFieldOption">
                            <input
                                type="radio"
                                name={fId}
                                checked={value === false}
                                onChange={() => onChange(fId, false)}
                            />
                            <span>לא</span>
                        </label>
                    </div>
                </div>
            );

        case 'shortText':
        default:
            return (
                <div className={wrapClass}>
                    {labelEl}
                    <input
                        id={fId}
                        type="text"
                        className="formFieldInput"
                        value={value || ''}
                        onChange={(e) => onChange(fId, e.target.value)}
                    />
                </div>
            );
    }
};

export default FormFieldRender;
